import { Component, ViewModel, ObservableArray, View } from "binder";
import  { ExactTimeView } from "./exactTime-view"

export class ExactTimeViewModel extends Component{
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
        this.items = ObservableArray.create<TimeItem>();
        this.items.update(...Array.from(new Array(24).keys()).map((x,i)=>{
            let r = new TimeItem(this);
            r.value=`${i.toString().padStart(2,'0')}:00`;
            return r;
        }));
        
    }
    GetDefaultView(): View <ViewModel> {
        return new ExactTimeView();
    }
    public getTypeId(): string {
        return "VM-C7EF3AE7-129B-4860-B919-70A01DA5547D"
    }

    public set items(v: ObservableArray<TimeItem>) { this._items = v; } public get items(): ObservableArray<TimeItem> { return this._items;} private _items: ObservableArray<TimeItem>;
    public set tabindex(v: number) { this._tabindex = v; } public get tabindex(): number { return this._tabindex;} private _tabindex: number;
    public set selectedtime(v: string) { 
        if(this._selectedtime != v){
            this._selectedtime = v;
            if(v==null)
                this.selecteditem = null;
            else
                this.selecteditem = this.items.filter(x=>x.value==v)[0]; 
        }
    } public get selectedtime(): string { return this._selectedtime;} private _selectedtime: string;
    public set selecteditem(v: TimeItem) { 
        this._selecteditem = v; 
        if(v==null)
            this.selectedtime = null;
        else
            this.selectedtime = v.value;
    } public get selecteditem(): TimeItem { return this._selecteditem;} private _selecteditem: TimeItem;
}

export class TimeItem extends ViewModel{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:ViewModel) {
        super(parent);
    }
    public set value(v: string) { this._value = v; } public get value(): string { return this._value;} private _value: string;
        
}
